import { size } from 'lodash';
import { AssignmentContent } from './AssignmentContent';
import { AssignmentPin } from './AssignmentPin';
import { AssignmentUtils } from './AssignmentUtils';

export interface AssignmentBasicInfo {
  name: string;
  message?: string | undefined;
  subject?: string | undefined;
  pin?: AssignmentPin | undefined; // First pin of the assignment
  numberOfPins: number;
  ownerId: string;
}

export namespace AssignmentBasicInfo {
  export function create(content: AssignmentContent): AssignmentBasicInfo {
    return {
      name: content.name,
      message: content.message,
      subject: content.subject,
      pin: AssignmentUtils.firstPin(content),
      numberOfPins: size(AssignmentUtils.pinsByAssignmentType(content)),
      ownerId: content.ownerId,
    };
  }
}
